// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './api/http'
import { Loading, Row, Col, Select, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { InfiniteScroll, MessageBox, Picker, Popup, DatetimePicker, Button, Spinner, Field, Radio } from 'mint-ui'
// eslint-disable-next-line no-unused-vars
import mui from '../static/js/mui.min.js'
import i18n from './i18n'
import 'mint-ui/lib/style.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.css'
import '../static/css/style.css'
import headertop from './components/headertop'
import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
// eslint-disable-next-line no-unused-vars
const vConsole = new VConsole() // 初始化
// import '../static/js/style.js'
// 公共js
import base from '../static/js/base.js'
// 配置文件
import { hostInvetory } from './config/env'
// dev
Vue.use(Loading)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(InfiniteScroll)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
// Vue.component(Loadmore.name, Loadmore);

mui.plusReady(function() {
  // 关闭启动页
  // eslint-disable-next-line no-undef
  plus.navigator.closeSplashscreen()
  // eslint-disable-next-line no-undef
  Vue.prototype.plus = plus
})
Vue.config.productionTip = false
Vue.prototype.Global = { hostInvetory }
Vue.prototype.$axios = axios
Vue.prototype.base = base

Vue.prototype.MessageBox = MessageBox
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(headertop.name, headertop)
Vue.component(Button.name, Button)
Vue.component(Spinner.name, Spinner)
Vue.component(Field.name, Field)
Vue.component(Radio.name, Radio)

router.beforeEach((to, from, next) => {
  //	console.log(localStorage.getItem('user'));
  //	localStorage.clear();
  //	console.log(window.location.href);
  if (store.state.login.loginstatus) {
    if (to.fullPath === '/login') {
      if (to.fullPath === '/home') {
        next()
      } else {
        next('/home')
      }
    } else {
      next()
    }
    if (to.fullPath === '/home') {
      base.upDataVersion() // 强制版本更新
    }
  } else {
    if (to.fullPath === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})
router.afterEach((to, from) => {
  if (base.data.loading != null) {
    base.loadClose()
  }
})
Vue.filter('removeSpace', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/(^\s*)|(\s*$)/g, '')
})
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js